import { Dispatch } from 'redux';
import { 
    setColor as setColorReducer
} from '../reducers/colors';

export const setColor = (code: string, label: string) => (dispatch: Dispatch) => _setColor(code, label, dispatch);
const _setColor = async (code: string, label: string, dispatch: Dispatch ) => dispatch({type: setColorReducer, payload: {code: code, label: label}});